import React from 'react';
import Slider from 'react-slick';
import Card from './Card';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Arrow = ({ direction, onClick }) => (
	<button
		onClick={onClick}
		aria-label={direction === 'prev' ? 'Previous' : 'Next'}
		style={{
			position: 'absolute',
			top: '50%',
			[direction === 'prev' ? 'left' : 'right']: '12px',
			transform: 'translateY(-50%)',
			zIndex: 10,
			background: 'rgba(245,200,66,0.08)',
			border: '1px solid rgba(245,200,66,0.22)',
			borderRadius: '8px',
			width: '36px',
			height: '36px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			cursor: 'pointer',
			color: 'var(--accent)',
			fontSize: '20px',
			lineHeight: 1,
			transition: 'background 0.2s',
		}}
		onMouseEnter={(e) =>
			(e.currentTarget.style.background = 'rgba(245,200,66,0.18)')
		}
		onMouseLeave={(e) =>
			(e.currentTarget.style.background = 'rgba(245,200,66,0.08)')
		}
	>
		{direction === 'prev' ? '‹' : '›'}
	</button>
);

const ProjectCarousel = ({ projects = [] }) => {
	const settings = {
		dots: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: <Arrow direction="prev" />,
		nextArrow: <Arrow direction="next" />,

		responsive: [
			{
				breakpoint: 768, // tablets & below
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	return (
		<div className="slider-container">
			<div
				style={{
					position: 'absolute',
					top: '14px',
					right: '18px',
					fontSize: '12px',
					color: 'var(--text-muted)',
					zIndex: 5,
					fontFamily: "'Syne', sans-serif",
					letterSpacing: '0.06em',
				}}
			>
				{projects.length} Projects
			</div>
			<Slider {...settings}>
				{projects.map((project, i) => (
					<div key={i}>
						<Card {...project} />
					</div>
				))}
			</Slider>
		</div>
	);
};

export default ProjectCarousel;
